import styled from "styled-components";

const EmailEditorStyle = styled.div`
    .upload-style {
        width: 150px;
        height: 37px;
        border-radius: 5px;
        background: none;
        font-size: 16px;
        font-weight: 400;
        color: #2d53da;
        border: none;
    }
    .file_list {
        background: #fff;
        padding: 5px;
    }
    .file_bg {
        background: #daebf7;
    }
    .Mos{
        position: absolute;
        right: 42px;
        margin-top: 20px;
    }
    .editor_modal_footer{
        margin-top: 12px;
        width: 100%;
        display: flex;
        justify-content: end;
        gap: 10px;
    }
    .cancel_button{
        width: 130px;
        height: 34px;
        border-radius: 8px;
    }
    .confirm_button{
        width: 130px;
        height: 34px;
        border-radius: 8px;
        background-color: #2D53DA !important;
        color: #fff;
    }
    .checkbox_group .ant-checkbox-wrapper {
        width: 100% !important;
    }
    .title{
        color: #1F243B;
        font-size: 18px;
        font-weight: 500;
    }
    .status_name{
        color: #636980;
        font-size: 14px;
    }
    .to_lable{
        color: #1F243B;
        font-size: 14px;
    }
    .emailid_label{
        color: #636980;
        font-size: 14px;
    }
    .hr_policies_wrapper{
        border: 1px solid #D9D9D9;
        border-radius: 6px;
        padding: 8px;
    }
    .status-moved-container{
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
`

export default EmailEditorStyle;